import useSWR, { SWRResponse } from 'swr';
import { AxiosError } from 'axios';
import { BrandTemplate } from '../../../providers/api/dtos';
import { getBrandTemplate } from '../../../providers/api/marketing/marketingProvider';

export const BRAND_TEMPLATE_BY_ID_RID = '/marketing/brand-templates/:id';

export default function useBrandTemplate(id?: string): SWRResponse<BrandTemplate, AxiosError> {
  return useSWR(
    id ? [BRAND_TEMPLATE_BY_ID_RID, id] : null,
    () => getBrandTemplate(id!),
  );
}
